import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { EditCatalogueModalComponent } from './edit-catalogue-modal.component';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class EditCatalogueModalService {
  private refreshListSource = new Subject<boolean>();

  refreshList$ = this.refreshListSource.asObservable();

  constructor(private dialog: MatDialog) {}

  open(config: MatDialogConfig<any> = new MatDialogConfig()) {
    const dialogRef = this.dialog.open(EditCatalogueModalComponent, config);

    return dialogRef.afterClosed().pipe(
      tap((res) => {
        this.refreshListSource.next(res);
      })
    );
  }
}
